import React, { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';
import { Icon } from './icon/Icon';

interface RowConfig {
	style?: CSSProperties;
	center?: boolean;
	children?: ReactNode;
	className?: string;
}

export const Row: React.FC<RowConfig> = ({ children, style, center, className }) => {
	return (
		<RowBody $center={center} style={style} className={className}>
			{children}
		</RowBody>
	);
};

const RowBody = styled.div<{ $center?: boolean }>`
	display: flex;
	align-items: center;
	${({ $center }) => $center && 'justify-content: center;'}
`;

export const Spacer: React.FC<{ size: number }> = ({ size }) => <SpaceBody $s={size} />;

const SpaceBody = styled.div<{ $s: number }>`
	${({ $s }) => `
  height: ${$s}px;
  width: ${$s}px;
  `}
`;

export const Fill = styled.div`
	display: flex;
	flex-grow: 1;
	flex: 1;
`;

interface CenterType {
	style?: CSSProperties;
	children?: ReactNode;
	className?: string;
}
export const Center: React.FC<CenterType> = ({ children, style, className }) => {
	return (
		<CenterB style={style} className={className}>
			{children}
		</CenterB>
	);
};

const CenterB = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

interface BoxWrapperConf {
	row?: boolean;
	style?: CSSProperties;
	smaller?: boolean;
	children?: ReactNode;
	className?: string;
}

export const BoxWrapper: React.FC<BoxWrapperConf> = ({ children, style, row, smaller, className }) => {
	return (
		<BoxWrapperB $row={row} $smaller={smaller} style={style} className={className}>
			{children}
		</BoxWrapperB>
	);
};

const BoxWrapperB = styled.div<{ $row?: boolean; $smaller?: boolean }>`
	display: flex;
	flex-direction: ${({ $row }) => ($row ? 'row' : 'column')};
	align-items: center;
	padding: 5px 20px;

	${({ $smaller }) => `
	@media only screen and (min-width: ${$smaller ? 800 : 1100}px) {
		justify-content: center;
		max-width: ${$smaller ? 800 : 1100}px;
		align-items: center;
		margin: 0 auto;
	}
	`}
`;

interface IconButtonProps {
	name: string;
	color: string;
	size: number;
	onClick?: () => void;
	style?: CSSProperties;
	className?: string;
}

export const IconButton: React.FC<IconButtonProps> = ({ name, color, size, onClick, style, className }) => {
	return <IconButtonB name={name} color={color} size={size} onClick={onClick} style={style} className={className} />;
};

const IconButtonB = styled(Icon)`
	cursor: pointer;
	&:hover {
		fill: red;
	}
`;
